import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { tokens } from '@equinor/eds-tokens';
import mergeDeepRight from '../../../node_modules/.pnpm/ramda@0.29.0/node_modules/ramda/es/mergeDeepRight.js';

var _tokens$typography = tokens.typography,
  _tokens$typography$ta = _tokens$typography.table,
  cellTypography = _tokens$typography$ta.cell_text,
  cellNumericTypography = _tokens$typography$ta.cell_numeric_monospaced,
  compactTypography = _tokens$typography._modes.compact,
  _tokens$colors = tokens.colors,
  typographyColor = _tokens$colors.text.static_icons__default.rgba,
  borderColor = _tokens$colors.ui.background__medium.rgba,
  _tokens$colors$intera = _tokens$colors.interactive,
  backgroundColor = _tokens$colors$intera.table__cell__fill_resting.rgba,
  hoverBackgroundColor = _tokens$colors$intera.table__cell__fill_hover.rgba,
  activeBackgroundColor = _tokens$colors$intera.table__cell__fill_activated.rgba,
  errorColor = _tokens$colors$intera.danger__highlight.rgba,
  primaryRestingColor = _tokens$colors$intera.primary__resting.rgba,
  disabledTextColor = _tokens$colors$intera.disabled__text.rgba,
  disabledBorderColor = _tokens$colors$intera.disabled__border.rgba,
  focusColor = _tokens$colors$intera.focus.rgba,
  medium = tokens.spacings.comfortable.medium;
var tableCell = {
  height: 'var(--eds_table__cell__height, 48px)',
  background: backgroundColor,
  align: {
    vertical: 'var(--eds_table__cell__vertical_align, inherit)'
  },
  border: {
    type: 'bordergroup',
    bottom: {
      color: borderColor,
      width: '1px',
      style: 'solid'
    }
  },
  spacings: {
    top: 'var(--eds_table__cell__padding_y, 0)',
    bottom: 'var(--eds_table__cell__padding_y, 0)',
    left: "var(--eds_table__cell__padding_x, ".concat(medium, ")"),
    right: "var(--eds_table__cell__padding_x, ".concat(medium, ")")
  },
  typography: _objectSpread(_objectSpread({}, cellTypography), {}, {
    color: typographyColor,
    fontSize: "var(--eds_table__font_size, ".concat(cellTypography.fontSize, ")")
  }),
  states: {
    active: {
      background: activeBackgroundColor,
      typography: _objectSpread(_objectSpread({}, cellTypography), {}, {
        color: primaryRestingColor
      }),
      border: {
        bottom: {
          color: primaryRestingColor
        }
      }
    },
    disabled: {
      typography: _objectSpread(_objectSpread({}, cellTypography), {}, {
        color: disabledTextColor
      }),
      border: {
        type: 'bordergroup',
        bottom: {
          color: disabledBorderColor
        }
      }
    },
    focus: {
      outline: {
        type: 'outline',
        color: focusColor,
        width: '1px',
        style: 'dashed'
      }
    },
    hover: {
      background: hoverBackgroundColor
    }
  },
  modes: {
    compact: {
      height: 'var(--eds_table__cell__height_compact, 32px)',
      typography: _objectSpread(_objectSpread({}, compactTypography.table.cell_text), {}, {
        color: typographyColor
      }),
      spacings: {
        top: 'var(--eds_table__cell__padding_y_compact, 0)',
        bottom: 'var(--eds_table__cell__padding_y_compact, 0)',
        left: "var(--eds_table__cell__padding_x_compact, ".concat(medium, ")"),
        right: "var(--eds_table__cell__padding_x_compact, ".concat(medium, ")")
      }
    }
  },
  validation: {
    error: {
      background: errorColor
    }
  },
  variants: {
    numeric: {
      typography: _objectSpread(_objectSpread({}, cellNumericTypography), {}, {
        color: typographyColor
      }),
      modes: {
        compact: {
          typography: _objectSpread(_objectSpread({}, compactTypography.table.cell_numeric_monospaced), {}, {
            color: typographyColor
          })
        }
      }
    }
  }
};
var applyVariant = function applyVariant(variant, token) {
  switch (variant) {
    case 'numeric':
      return mergeDeepRight(token, token.variants.numeric);
    default:
      return token;
  }
};

export { applyVariant, tableCell };
